import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
// import { JwtHelperService } from "@auth0/angular-jwt";
import { LoggedInUserInfo } from "src/app/shared/model/LoggedInUserInfo";
import { AuthService } from "src/app/shared/services/auth.service";
import { CommonService } from "src/app/shared/services/common-service.service";
import { DataStorageService } from "src/app/shared/services/data-storage.service";
import { NotificationService } from "src/app/shared/services/notification.service";
import { environment } from "src/environments/environment";
import { DataService } from "src/app/service/data.service";
import { AlertService } from "src/app/service/alert.service";
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {

decodedToken: any;
jwtHelper: JwtHelperService = new JwtHelperService();
currentUser: any;
  user: LoggedInUserInfo = {
    UserName: "",
    UserID: 0,
    Token: ""
  };
  //sosApiEndPoint=environment.sosApiEndPoint;

constructor(private dataService: DataService,private alertService: AlertService, private authService: AuthService, private router: Router,private commonService: CommonService) { }//, 

ngOnInit(): void {
  //debugger
  if (environment.production == false) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    //debugger
    this.dataService.getData("User/GetToken").subscribe(response => {
      //debugger
      const user = response;
      if (user.token) {
        //debugger
        localStorage.setItem('token', user.token.trim());
        localStorage.setItem('user', JSON.stringify(user.user));
        localStorage.setItem('userid', user.user.Id);
        localStorage.setItem('UserID', user.user.Id);
        localStorage.setItem('empcode', '');
        this.decodedToken = this.jwtHelper.decodeToken(user.token);
        this.currentUser = user.user;

        this.user.Token =user.token.trim();
        this.user.UserID = user.user.Id;
        this.router.navigate(["/dashboard/default"], {
         //this.router.navigate(["/login"], { 
          skipLocationChange: true,
        });

      }
              else {
                //debugger
          this.commonService.logoutRedirect();
        }
    }, e => {
      this.alertService.error(e);
    }, () => { })
  }
  else {      
    if (!this.authService.loggedIn()) {
      this.alertService.error('Please login to continue...');
      document.location.href = environment.intranetLogin;
    }
    else{
      //debugger
      this.router.navigate(['/dashboard/default']);
      //this.router.navigate(['/login/login-user']);
      //this.router.navigate(["/login"]);
    }
  }
}
}



//   decodedToken: any;
//   currentUser: any;
//   user: LoggedInUserInfo = {
//     UserName: "",
//     UserID: 0,
//     Token: ""
//   };
//   sosApiEndPoint=environment.sosApiEndPoint;
//   constructor(
//     private dataService: DataStorageService,
//     private alertService: NotificationService,
//     private authService: AuthService,
//     private router: Router,
//     private commonService: CommonService
//   ) {
//     let user = JSON.parse(localStorage.getItem('UserID'));
//     if (!user || user === null) {
//       this.checkUser();
//     } else {
//       this.router.navigate(["/dashboard/default"], {
//         skipLocationChange: true,
//       });
//     }
//    }

//   ngOnInit(): void {
//   }

//   async checkUser() {
//     //debugger
//     await this.dataService
//       .postSoSData(this.sosApiEndPoint+"api/Authenticate/CheckUser").subscribe((res: any) => {
//         if (res.Token != "" && res.Token != null) {
//           localStorage.setItem("token", (res.Token).trim());
//           this.user.Token = (res.Token).trim();
//           localStorage.setItem("UserID", res.userID);
//           this.user.UserID = parseInt(res.userID);
//           localStorage.setItem("user", JSON.stringify(this.user));
//           this.router.navigate(["/dashboard/default"], {
//             skipLocationChange: true,
//           });
//         }
        
//         else {
//           this.commonService.logoutRedirect();
//         }

//       });
//   }
//   async getMenu() {
//     let UserID = localStorage.getItem("UserID");
//     await this.dataService
//       .getData("Master/GetMenuList/" + parseInt(UserID) + "/22")
//       .subscribe((res: any) => {
//         let list = JSON.parse(JSON.parse(res).Response)[0].menuItems;
//         list.forEach((row) => {
//           this.commonService.MenuList.push({
//             path: row.UI_URL,
//             icon: "framer",
//             title: row.MENU_NAME,
//             type: "link",
//           });
//         });
//         this.router.navigate(["/dashboard/default"], {
//           skipLocationChange: true,
//         });
//       });
//   }
// }
